import constant from '../../constant'

const initialState = { 
  miniCollection: {
    collections: [],
    name: ''
  }
};

export function videoInfo (state = initialState, action) {
  switch (action.type) {
    case constant.VIDEO.GET_VIDEO_INFO:
      return {
        ...state,
        ...action.videoInfo
      }
    case constant.VIDEO.GET_MINI_VIDEO_COLLECTION:
      return {
        ...state,
        miniCollection: action.videoCollection
      }
    default:
      return state
  }

}